(function () {
  function toInt(value, fallback) {
    var number = parseInt(value, 10);

    return Number.isFinite(number) && number > 0
      ? number
      : fallback;
  }

  function roundUpToMultiple(quantity, step) {
    if (quantity % step === 0) {
      return quantity;
    }

    return quantity + (step - (quantity % step));
  }

  function parseCasePackMap(modalRoot) {
    var mapScript = modalRoot.querySelector(
      '[data-b2b-variant-case-pack-map]'
    );

    if (!mapScript) {
      return {};
    }

    try {
      return JSON.parse(mapScript.textContent);
    } catch (error) {
      console.warn(
        'Quick Shop variant case-pack map could not be parsed.',
        error
      );

      return {};
    }
  }

  function applyCasePack(
    modalRoot,
    fallbackCasePack
  ) {
    if (
      !modalRoot ||
      modalRoot.__casePackEnhanced
    ) {
      return;
    }

    var form = modalRoot.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) {
      return;
    }

    var quantityInput = modalRoot.querySelector(
      'input[name="quantity"]'
    );

    if (!quantityInput) {
      return;
    }

    modalRoot.__casePackEnhanced = true;

    var casePackMap =
      parseCasePackMap(modalRoot);

    var variantSelection = modalRoot.querySelector(
      'variant-selection[data-variant-selection]'
    );

    var variantInput =
      form.querySelector('[name="id"]');

    var minusButton = modalRoot.querySelector(
      '[data-quantity-minus]'
    );

    var plusButton = modalRoot.querySelector(
      '[data-quantity-plus]'
    );

    var minusWrapper = modalRoot.querySelector(
      '[data-button-wrapper-minus]'
    );

    var currentCasePack = toInt(
      fallbackCasePack,
      1
    );

    function getVariantId() {
      if (
        variantInput &&
        variantInput.value &&
        variantInput.value !== 'not-selected'
      ) {
        return variantInput.value;
      }

      return null;
    }

    function getCasePack(variantId) {
      return toInt(
        casePackMap[String(variantId || '')],
        currentCasePack
      );
    }

    function updateMinusButton() {
      if (!minusWrapper) {
        return;
      }

      var quantity = toInt(
        quantityInput.value,
        currentCasePack
      );

      if (quantity <= currentCasePack) {
        minusWrapper.classList.add(
          'quantity-selector__button-wrapper--disabled'
        );
      } else {
        minusWrapper.classList.remove(
          'quantity-selector__button-wrapper--disabled'
        );
      }
    }

    function updateCasePackDisplay() {
      var productTexts =
        modalRoot.querySelectorAll('.product-text');

      productTexts.forEach(function (element) {
        var text =
          (element.textContent || '').toLowerCase();

        if (text.indexOf('case pack') === -1) {
          return;
        }

        var valueElement =
          element.querySelector('strong');

        if (valueElement) {
          valueElement.textContent =
            currentCasePack;
        }
      });
    }

    function dispatchQuantityUpdate() {
      quantityInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    function setQuantity(quantity) {
      quantity = toInt(
        quantity,
        currentCasePack
      );

      quantity = Math.max(
        currentCasePack,
        roundUpToMultiple(
          quantity,
          currentCasePack
        )
      );

      quantityInput.value =
        String(quantity);

      updateMinusButton();
      dispatchQuantityUpdate();
    }

    function applyVariant(variantId) {
      currentCasePack =
        getCasePack(variantId);

      quantityInput.min =
        String(currentCasePack);

      quantityInput.step =
        String(currentCasePack);

      quantityInput.dataset.incrementValue =
        String(currentCasePack);

      if (minusButton) {
        minusButton.setAttribute(
          'aria-label',
          'Decrease quantity by ' +
            currentCasePack
        );
      }

      if (plusButton) {
        plusButton.setAttribute(
          'aria-label',
          'Increase quantity by ' +
            currentCasePack
        );
      }

      updateCasePackDisplay();
      setQuantity(currentCasePack);
    }

    modalRoot.addEventListener(
      'click',
      function (event) {
        var clickedMinus =
          event.target.closest(
            '[data-quantity-minus]'
          );

        var clickedPlus =
          event.target.closest(
            '[data-quantity-plus]'
          );

        if (
          !clickedMinus &&
          !clickedPlus
        ) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var quantity = toInt(
          quantityInput.value,
          currentCasePack
        );

        if (clickedPlus) {
          setQuantity(
            quantity + currentCasePack
          );
        } else {
          setQuantity(
            quantity - currentCasePack
          );
        }
      },
      true
    );

    quantityInput.addEventListener(
      'change',
      function () {
        setQuantity(quantityInput.value);
      }
    );

    quantityInput.addEventListener(
      'blur',
      function () {
        setQuantity(quantityInput.value);
      }
    );

    if (variantSelection) {
      variantSelection.addEventListener(
        'variant-change',
        function (event) {
          var variant =
            event.detail &&
            event.detail.variant
              ? event.detail.variant
              : null;

          if (variant) {
            applyVariant(variant.id);
          }
        }
      );

      if (
        typeof variantSelection.getVariant ===
        'function'
      ) {
        variantSelection
          .getVariant()
          .then(function (variant) {
            applyVariant(
              variant
                ? variant.id
                : getVariantId()
            );
          });
      } else {
        applyVariant(getVariantId());
      }
    } else {
      applyVariant(getVariantId());
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(
        '[data-quickshop-full], [data-quickshop-slim]'
      );

      if (!button) {
        return;
      }

      var card = button.closest(
        '[data-product-item][data-case-pack]'
      );

      var fallbackCasePack = card
        ? toInt(
            card.getAttribute('data-case-pack'),
            1
          )
        : 1;

      var timeoutId = null;

      var observer =
        new MutationObserver(function (mutations) {
          for (
            var mutationIndex = 0;
            mutationIndex < mutations.length;
            mutationIndex += 1
          ) {
            var mutation =
              mutations[mutationIndex];

            for (
              var nodeIndex = 0;
              nodeIndex <
              mutation.addedNodes.length;
              nodeIndex += 1
            ) {
              var node =
                mutation.addedNodes[nodeIndex];

              if (
                !(node instanceof HTMLElement)
              ) {
                continue;
              }

              var modal =
                node.matches &&
                node.matches(
                  '[role="dialog"], .modal, .drawer'
                )
                  ? node
                  : null;

              if (
                !modal &&
                node.querySelector
              ) {
                modal = node.querySelector(
                  '[role="dialog"], .modal, .drawer'
                );
              }

              if (!modal) {
                continue;
              }

              if (
                modal.querySelector &&
                modal.querySelector(
                  'form[action*="/cart/add"]'
                )
              ) {
                applyCasePack(
                  modal,
                  fallbackCasePack
                );

                observer.disconnect();

                if (timeoutId) {
                  clearTimeout(timeoutId);
                }

                return;
              }
            }
          }
        });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      timeoutId = setTimeout(function () {
        observer.disconnect();
      }, 5000);
    },
    true
  );
})();